export default {
    BP_VALID_COEFFICIENT: 300
}
